import { SettingIds } from '../types/settings.type';

export const PointSystemSettingsIds = [
  SettingIds.POINT_SYSTEM_DISCORD_ENABLED,
  SettingIds.POINT_SYSTEM_TELEGRAM_BOT_NAME,
  SettingIds.POINT_SYSTEM_TELEGRAM_BOT_ID,
  SettingIds.POINT_SYSTEM_TELEGRAM_ENABLED,
  SettingIds.POINT_SYSTEM_TELEGRAM_GROUP_ID,
  SettingIds.POINT_SYSTEM_TELEGRAM_GROUP_NAME,
  SettingIds.POINT_SYSTEM_TWITTER_ACCOUNT_ID,
  SettingIds.POINT_SYSTEM_TWITTER_ACCOUNT_NAME,
  SettingIds.POINT_SYSTEM_TWITTER_ENABLED,
  SettingIds.POINT_SYSTEM_TWITTER_JOB_ENABLED,
  SettingIds.POINT_SYSTEM_GUIDE_LINK,
];
